module.exports = __webpack_public_path__ + "img/45.59ba0668.png";